/** @module SiteAdmin/SelectSet/SubtypeNameRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/String",
	"csi/locale",
	"csi/xml"
], function(declare,csiHeading,StringRen,locale,xml) {

	function _format(value) {
		return locale.resourceIfExists("SelectSetSubtype_" + value) || locale.type(value) || "";
	}

	return declare(StringRen, {
		// limit query operations to EQ/NE so the client can send full class names to the server to filter by (substrings won't work)
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_ENUM],

		formatValue: _format,
		_toSortValue: _format
	});
});